module.exports = __webpack_public_path__ + "media/images/data_map_demo-fefaa0e1545f7ff44ed46ec5ca57c8b7.png";